document.documentElement.classList.remove('no-js');
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.product-card__form');
  if (!form || !window.fetch) return;
  event.preventDefault();
  const button = form.querySelector('button'); const label = button.textContent;
  button.disabled = true; button.textContent = 'Adding…';
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error('Unable to add item');
    button.textContent = 'Added'; document.dispatchEvent(new CustomEvent('cart:updated'));
  } catch (error) { button.textContent = 'Try again'; }
  setTimeout(() => { button.disabled = false; button.textContent = label; }, 1600);
});
